import React, { useState, useEffect } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import AuditActions from "../../Actions/AuditActions";
import auditStore from "../../Stores/AuditStores";
import AuditConstants from "../../Constants/AuditConstants";

function AuditObjectLog(props) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { translate, localization } = useLanguageContext();
  const { auditObjectLogId, closeAuditObjectLog } = props;
  const [logObjectList, setLogObjectList] = useState([]);

  useEffect(() => {
    if (auditObjectLogId) {
      AuditActions.getObjectLog(auditObjectLogId);
    }
  }, [props]);

  useEffect(() => {
    function getAuditObjectFieldSuccess() {
      var res = auditStore.getAuditObjectLog();
      if (res.length > 0) {
        setLogObjectList(res);
        setGlobalSpinner(false);
      } else {
        setLogObjectList([]);
        setGlobalSpinner(false);
      }
    }

    function getAuditObjectFieldFailure() {
      setGlobalSpinner(false);
    }

    auditStore.addChangeListener(
      AuditConstants.GET_AUDIT_OBJECT_LOG_SUCCESS,
      getAuditObjectFieldSuccess
    );

    auditStore.addChangeListener(
      AuditConstants.GET_AUDIT_OBJECT_LOG_FAILURE,
      getAuditObjectFieldFailure
    );
    return () => {
      auditStore.removeChangeListener(
        AuditConstants.GET_AUDIT_OBJECT_LOG_SUCCESS,
        getAuditObjectFieldSuccess
      );

      auditStore.removeChangeListener(
        AuditConstants.GET_AUDIT_OBJECT_LOG_FAILURE,
        getAuditObjectFieldFailure
      );
    };
  }, []);

  function handleclose() {
    setLogObjectList([]);
    closeAuditObjectLog();
  }

  return (
    <>
      <div
        className="modal fade"
        id="auditObjectLog"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="auditObjectLog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div
          className="modal-dialog d-flex  justify-content-center"
          role="document"
        >
          <div className="modal-content" style={{ minWidth: "90rem" }}>
            <div className="modal-header">
              <div className="container">
                <div className="row d-flex">
                  <div className="col">
                    <h5 id="auditObjectLog">{localization.objectLog}</h5>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="auditObjectLogcloseModal"
                onClick={() => {
                  handleclose();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body auditObjbody pt-0">
              <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                <thead className="bg-light">
                  <tr>
                    <th>{localization.operation}</th>
                    <th>{localization.auditOf}</th>
                    <th>{localization.identifier}</th>
                    <th>{localization.field}</th>
                    <th>{localization.oldValue}</th>
                    <th>{localization.newValue}</th>
                    <th>{localization.performedBy}</th>
                    <th>{localization.performedOn}</th>
                  </tr>
                </thead>
                <tbody>
                  {logObjectList.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.operation}</td>
                        <td>{item.auditOf}</td>
                        <td>{item.identifer}</td>
                        <td>{item.field}</td>
                        <td>{item.oldValue}</td>
                        <td>{item.newValue}</td>
                        <td>{item.user}</td>
                        <td>{item.updatedOn}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuditObjectLog;
